import React from "react";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

// Wraps routed page content so navigating between pages cross-fades with a
// small upward slide instead of hard-cutting -- keyed on pathname so
// AnimatePresence treats each route as a distinct child to transition
// between. Kept fast (~180ms) and subtle: this should remove the "jump
// cut," not be a showcase animation.
export default function PageTransition({ children }) {
  const { pathname } = useLocation();

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={pathname}
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -8 }}
        transition={{ duration: 0.18, ease: "easeOut" }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
